import { Button, TextField, Typography, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import GoogleButton from '../googlebutton/GoogleButton';
import { useGoogleSignIn } from '../hooks/useGoogleSignIn';
import { useEmailRegister } from '../hooks/useEmailRegister';
import {
  StyledContainer,
  StyledFormContainer,
  StyledGoogleButtonContainer,
  StyledDividerContainer,
  StyledDividerText,
  StyledDivider,
  StyledForm,
  StyledLoginLink
} from './Register.styled';

export default function RegisterPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: ''
  });
  const { isLoading: isGoogleLoading, error: googleError, handleGoogleSignIn } = useGoogleSignIn();
  const { isLoading: isEmailLoading, error: emailError, handleEmailRegister } = useEmailRegister();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await handleEmailRegister(formData.email, formData.password, formData.confirmPassword);
  };

  const isLoading = isGoogleLoading || isEmailLoading;
  const error = googleError || emailError;

  return (
    <StyledContainer maxWidth="sm">
      <StyledFormContainer>
        <Typography variant="h4" component="h1" gutterBottom>
          Registrierung
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Erstellen Sie ein neues Konto oder nutzen Sie Google
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}

        <StyledGoogleButtonContainer>
          <GoogleButton isLoading={isLoading} handleGoogleSignIn={handleGoogleSignIn} />
        </StyledGoogleButtonContainer>

        <StyledDividerContainer>
          <StyledDividerText variant="caption">
            ODER MIT E-MAIL REGISTRIEREN
          </StyledDividerText>
          <StyledDivider />
        </StyledDividerContainer>

        <StyledForm onSubmit={handleSubmit}>
          <TextField
            id="email"
            name="email"
            label="Email"
            type="email"
            placeholder="email@example.com"
            required
            fullWidth
            value={formData.email}
            onChange={handleInputChange}
            disabled={isLoading}
          />
          <TextField
            id="password"
            name="password"
            label="Password"
            type="password"
            placeholder="********"
            required
            fullWidth
            value={formData.password}
            onChange={handleInputChange}
            disabled={isLoading}
          />
          <TextField
            id="confirmPassword"
            name="confirmPassword"
            label="Confirm Password"
            type="password"
            placeholder="********"
            required
            fullWidth
            value={formData.confirmPassword}
            onChange={handleInputChange}
            disabled={isLoading}
          />
          <Button
            variant="contained"
            type="submit"
            fullWidth
            sx={{ mt: 1 }}
            disabled={isLoading}
          >
            {isLoading ? 'Registrierung...' : 'Registrieren'}
          </Button>
          <StyledLoginLink
            variant="body2"
            onClick={() => navigate('/login')}
          >
            Bereits ein Konto? Hier anmelden!
          </StyledLoginLink>
        </StyledForm>
      </StyledFormContainer>
    </StyledContainer>
  );
} 